export default __webpack_public_path__ + "static/media/temp.aa236718.svg";